var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page404"},[_c('p',[_vm._v(_vm._s(_vm.$t('page404.pageNotExist')))]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("返回首页")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }